import { Component, OnInit, ViewChild } from '@angular/core';
import { FileSelectDirective, FileDropDirective, FileUploader, FileItem, FileLikeObject} from 'ng2-file-upload';
import { SecurityService } from '../../Core/Security/security.service';
import { LogService } from '../../Core/Abstract/log.service';
import { VisualsService } from '../../Core/Abstract/visuals.service';
import { Observable } from 'rxjs';
import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
//If service needed
//import { RecFileUploadService } from './recFileUpload.service';

@Component({
    selector: 'baseUploaderComponent',
    template: ''
})

export abstract class BaseUploaderComponent implements OnInit{
    @ViewChild('errorModal',{static: false}) public errorModal: ModalDirective;
    @ViewChild('fileUpload',{static: false}) fileUpload: any;

    protected group = "";
    protected visuals:any = {};
    protected genericVisuals:any = {};
    //Uploader Constractor vars
    protected URL = '';
    protected uploader:FileUploader;
    protected uploading:boolean = false;
    protected allowedMimeType = ['text/plain'];
    protected displayAllowedMimeType;
    protected maxFileSize  = 10 * 1024 * 1024; // 10MB
    protected queueLimit = 1;

    //File drop/select message
    protected quequeMsg:string = "";

    //Response message
    protected resultType:boolean = true;
    protected resultMsg:string = "";
    protected resultDetails:any = [];

    protected intRegex = /(^0$)|(^[1-9]\d*$)/;
    
    constructor(protected securityService: SecurityService,
                protected configService: ConfigService,
                protected logger: LogService,
                protected visualsService: VisualsService,
                protected eventsEmitterService: EventsEmitterService ) {

        this.initLoader()
    }

    ngOnInit() {
        this.uploader.onBeforeUploadItem = (item) => {
            item.withCredentials = false;
        }
        this.uploader.onAfterAddingFile = (item) => { this.quequeMsg = "" };

        this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);
    }

    protected onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
        this.quequeMsg = "";
        this.logger.log(filter.name);
        switch (filter.name) {
            case 'fileSize':
                this.quequeMsg = this.visuals.fileSize + this.maxFileSize / 1024 / 1024 + "(MB)";
                break;
            case 'mimeType':
                this.quequeMsg =  this.visuals.mimeType + this.displayAllowedMimeType.join();
                break;
            case 'queueLimit':
                this.quequeMsg =  this.visuals.queueLimit; //+ " ( Max " + this.queueLimit + " )";
                this.fileUpload.nativeElement.value = '';
                this.uploader.clearQueue();
                break;
            default:
                this.logger.log("Unknown error, filter = " + filter.name);
                this.quequeMsg = this.visuals.uploadGenericError;
        }
    }

    protected removeCustom(item:FileItem){
        //trick to be able to remove and add the same item
        this.fileUpload.nativeElement.value = '';
        item.remove();
        this.uploader.clearQueue();
    }


    protected uploadCustom(item:FileItem){
        this.uploading = true;
        this.securityService.checkToken().subscribe(
            data => {
                this.uploader.authToken = "Bearer " +this.securityService.getFromStorage('access_token');
                item.upload();

                this.uploader.onCompleteItem = (item: any, response: any, status: any, headers:any)=>  {
                    if( status == 200 ) {
                        this.resultType = true;
                        this.resultMsg = this.visuals.dataSuccess || 'Success';
                        this.uploading = false;

                        this.uploadSuccessCallback();
                    } else {
                        this.resultType = false;
                        this.resultMsg = this.visuals.dataError || 'Error';
                        this.logger.log(response)
                        if(response) {
                            if (/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(response) ){
                                this.resultDetails = [this.visuals.uploadGenericError];
                            } else {
                                try {
                                    let jsonResponse = JSON.parse(response)
                                    this.resultDetails = jsonResponse['errorList'];
                                } catch(e) {
                                    this.resultDetails = [response];
                                }
                            }
                        } else {
                            this.resultDetails = [this.visuals.uploadGenericError];
                        }
                        this.uploading = false;
                    }

                };
            },
            error => {
                this.uploading = false;
                return Observable.throw(error);
            }
        );

    }

    protected getVisuals(){
        this.genericVisuals = this.visualsService.getFromStorageAsJSON('visualsArray')['generic'];        
        this.visuals = this.visualsService.getFromStorageAsJSON('visualsArray')[this.group];
    }

    protected abstract initLoader():void

    public hasBaseDropZoneOver:boolean = false;
    public hasAnotherDropZoneOver:boolean = false;

    public fileOverBase(e:any):void {
        this.hasBaseDropZoneOver = e;
    }

    public fileOverAnother(e:any):void {
        this.hasAnotherDropZoneOver = e;
    }


    public showChildModal(): void {
        this.errorModal.show();
    }

    public hideChildModal(): void {
        this.errorModal.hide();
    }

    public uploadSuccessCallback(){}
}
